<div class="container my-4">
  <div *ngIf="assignment">
    <!-- Title -->

    <div class="page-header-container">
      <div class="page-title-container">
        <button class="back_icon me-2" (click)="goBack()">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
        <h1 class="page-title">{{ assignment.subject }} <span translate>Questions</span></h1>
      </div>
    </div>

    <!-- Questions -->
    <div class="grid bg-white p-4">
      <ng-container *ngIf="!isSubmitted || showDetails === true">
        <ng-container
          *ngFor="
            let question of assignment.questions;
            let i = index;
            trackBy: trackByIndex
          "
        >
          <mat-card class="transition-all duration-300 border border-slate-200">
            <!-- Card Header -->
            <mat-card-header
              class="bg-gradient-to-r from-slate-100 to-slate-50 rounded-t-2xl px-6 py-4 border-b"
            >
              <mat-card-title
                class="text-lg md:text-xl font-semibold text-slate-700 tracking-wide"
              >
                <span translate>Question</span> {{ i + 1 }}
              </mat-card-title>
            </mat-card-header>

            <!-- Card Content -->
            <mat-card-content class="p-8 space-y-6">
              <!-- Question Text -->
              <p class="text-lg text-gray-900 font-medium leading-relaxed">
                {{ question.questionText }}
              </p>
              <button
                matButton="outlined"
                color="secondary"
                class="rounded-full my-4 shadow-md"
              >
                <i class="fa-solid fa-link"></i> <span translate>Reference File</span>
              </button>

              <!-- Answer Field -->
              <mat-form-field
                appearance="fill"
                class="w-100"
                floatLabel="always"
              >
                <mat-label><b translate>Answer:</b></mat-label>
                <textarea
                  matInput
                  matTextareaAutosize
                  matAutosizeMinRows="3"
                  matAutosizeMaxRows="8"
                  rows="5"
                  [disabled]="isDisabled"
                  class="text-base px-4 py-3 rounded-lg"
                  [(ngModel)]="question.answer"
                ></textarea>
              </mat-form-field>

              <!-- Upload Section -->
              <div
                class="flex flex-col md:flex-row items-start md:items-center gap-4"
              >
                <button
                  mat-flat-button
                  color="primary"
                  class="rounded-full px-6 my-4 shadow-md"
                  (click)="fileInput.click()"
                  *ngIf="!isDisabled"
                >
                  <i class="fa-solid fa-upload me-2"></i>
                  <span translate>Upload File</span>
                </button>
                <input
                  type="file"
                  hidden
                  #fileInput
                  (change)="onFileSelect($event, i)"
                />

                <div
                  *ngIf="question.file"
                  class="flex items-center gap-2 text-sm bg-slate-50 px-3 py-2 rounded-lg border text-gray-700"
                >
                  <mat-icon color="primary" class="text-base"
                    translate>description</mat-icon
                  >
                  <span class="font-medium">{{ question.file.name }}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </ng-container>
        <div class="button-wrapper">
          <button
            mat-flat-button
            color="primary"
            *ngIf="!isSubmitted"
            class="submit-button"
            (click)="submitAssignment()"
          >
            <i class="fa-solid fa-paper-plane"></i>
            <span translate>Submit Answers</span>
          </button>
        </div>
      </ng-container>
      <div
        *ngIf="isSubmitted && !showDetails"
        class="mt-9 text-center text-green-600 text-xl font-semibold tracking-wide"
      >
        <app-submitted-success-component
          [assignment]="assignment"
          [imageUrl]="imageUrl"
          [isSubmitted]="isSubmitted"
          [showDetails]="showDetails"
          [isDisabled]="isDisabled"
          (goBackEvent)="goBack()"
          (viewSubmissionDetailsEvent)="viewSubmissionDetails()"
        ></app-submitted-success-component>
      </div>
      <!-- <div
        *ngIf="isSubmitted && !showDetails"
        class="mt-9 text-center text-green-600 text-xl font-semibold tracking-wide"
      >
        <img
          [src]="imageUrl"
          alt="Success"
          style="width: 120px; margin-bottom: 16px"
        />
        <h1>Your assignment has been submitted successfully!</h1>
        <div class="mt-6 flex justify-center p-2">
          <table
            class="min-w-[500px] border border-gray-300 text-left bg-white rounded-lg"
          >
            <tr class="bg-gray-100">
              <th class="p-3 border">Subject</th>
              <td class="p-3 border">{{ assignment?.subject }}</td>
            </tr>
            <tr>
              <th class="p-3 border">Assignment Title</th>
              <td class="p-3 border">{{ assignment?.assignmentTitle }}</td>
            </tr>
            <tr>
              <th class="p-3 border">Class</th>
              <td class="p-3 border">{{ assignment?.class }}</td>
            </tr>
          </table>
        </div>
        <div class="d-flex justify-content-center gap-3">
          <button
            mat-flat-button
            color="primary"
            class="mt-6 px-6 py-2 rounded-lg"
            (click)="goBack()"
          >
            <i class="fa-solid fa-arrow-left me-2"></i>
            Back to assignments
          </button>
          <button
            mat-flat-button
            color="primary"
            class="mt-6 px-6 py-2 rounded-lg"
            (click)="viewSubmissionDetails()"
          >
            <i class="fa-solid fa-eye me-2"></i>
            View Submisstion Details
          </button>
        </div>
      </div>
    </div> -->
    </div>

    <!-- Empty State -->
    <div
      *ngIf="!assignment"
      class="text-center text-gray-500 p-16 rounded-2xl bg-gray-50 shadow-inner"
    >
      <p class="text-2xl mb-2 font-semibold" translate>Assignment not found.</p>
      <button
        mat-flat-button
        color="primary"
        routerLink="/assignments"
        class="mt-6 px-6 py-2 rounded-lg"
        translate
      >
        Go Back to Assignments
      </button>
    </div>
  </div>
</div>
